import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CmsService } from '@spartacus/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-data-protection',
  templateUrl: './data-protection.component.html',
  styleUrls: ['./data-protection.component.scss'],
  standalone: false
})
export class DataProtectionComponent {
  termsOfUse: any;
  subscription = new Subscription();
  constructor(private dialogRef: MatDialogRef<DataProtectionComponent>, private cmsService: CmsService) {

  }

  accept() {
    this.dialogRef.close(true);
  }
  ngOnInit() {
    this.subscription.add(this.cmsService.getComponentData('dataProtectionNA').subscribe((data: any) => {
      if (data) {
        this.termsOfUse = data.content;
      }
    }))
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}
